import store from 'store/store';
import { setContext } from 'modules/common/commonSlice';

const initApp = context => {
  store.dispatch(setContext(context));
};

export default initApp;
